import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/managementReducer'

export { selectors }

export default function useManagement(selector) {
  return useSelector(state => selector(state.management), shallowEqual)
}